var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 87 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8229,
    cy: 44.0353,
    r: 21.8229,
    fill: "#113252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3694 50.3016L37.6973 35.1915C37.0554 34.5727 35.9974 34.6278 35.3352 35.3146L34.6355 36.0403C33.9733 36.7271 33.9569 37.7865 34.5988 38.4054L50.2708 53.5155C50.9127 54.1343 51.9707 54.0792 52.6329 53.3924L53.3326 52.6667C53.9948 51.9799 54.0113 50.9205 53.3694 50.3016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4049 53.7504L52.5149 38.0784C53.1338 37.4365 53.0787 36.3785 52.3919 35.7163L51.6662 35.0166C50.9793 34.3544 49.92 34.3379 49.3011 34.9798L34.1911 50.6518C33.5722 51.2937 33.6273 52.3518 34.3141 53.014L35.0398 53.7137C35.7266 54.3759 36.786 54.3923 37.4049 53.7504Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButtonIcon);
export default __webpack_public_path__ + "static/media/CrossButtonIcon.bf9cf818914ca4f6be7833d061c56c7b.svg";
export { ForwardRef as ReactComponent };